import type { SortOptionT } from '@/components/DataTable/Sorter/types';

export const FEEDBACK_SORT_OPTIONS: SortOptionT[] = [
  {
    sortKey: 'date',
    sortName: 'Date',
    orderType: 'date',
  },
  {
    sortKey: 'tid',
    sortName: 'ID',
    orderType: 'string',
  },
  {
    sortKey: 'engagement.total',
    sortName: 'Total Engagement',
    orderType: 'number',
  },
  {
    sortKey: 'engagement.rate',
    sortName: 'Engagement Rate',
    orderType: 'number',
  },
  {
    sortKey: 'impression',
    sortName: 'Impression',
    orderType: 'number',
  },
  {
    sortKey: 'engagement.comment_count',
    sortName: 'Comment Count',
    orderType: 'number',
  },
  {
    sortKey: 'engagement.like_count',
    sortName: 'Like Count',
    orderType: 'number',
  },
  {
    sortKey: 'engagement.share_count',
    sortName: 'Share Count',
    orderType: 'number',
  },
  {
    sortKey: 'engagement.subscribe_count',
    sortName: 'Subscribe Count',
    orderType: 'number',
  },
  {
    sortKey: 'engagement.view_count',
    sortName: 'View Count',
    orderType: 'number',
  },
  {
    sortKey: 'engagement.votes_up_count',
    sortName: 'Up Votes',
    orderType: 'number',
  },
  {
    sortKey: 'engagement.votes_down_count',
    sortName: 'Down Votes',
    orderType: 'number',
  },
];
